import styled from "styled-components";

export default styled.div`
  position: fixed;
  bottom: ${({ theme }) => theme.margin.large};
  right: ${({ theme }) => theme.margin.large};
  z-index: 100;
`;
